import { useRoutes } from 'react-router-dom';
import { useAuth } from '~/providers/AuthProvider';
import PageLoading from '~/components/common/PageLoading';
import { useUnifiedAuthContext } from '~/providers/UnifiedAuthProvider';
import { useMemo } from 'react';
import { authRoutes } from './auth';
import { protectedRoutes } from './protected';

export const AppRoutes = () => {
  const { hasAccount, isFetchingAccounts } = useAuth();
  const { isVerifyingSSO } = useUnifiedAuthContext();

  const routes = useMemo(() => {
    if (hasAccount) return protectedRoutes();
    return authRoutes;
  }, [hasAccount]);

  const element = useRoutes(routes);
  const isPageLoading = isFetchingAccounts || isVerifyingSSO;
  if (isPageLoading) return <PageLoading loading />;
  return element;
};
